import type { App } from 'vue';
declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		$filterPrice: (price: number | string) => string | number;  //定义的$test的类型
	}
}
export function setupGlobalMethods(app: App) {
	app.config.globalProperties.$filterPrice = (price: number | string) => {
		price = Number(price).toFixed(2);
		if (Number(price) > 999) {
			return Number(price).toString().replace(/\d+/, function (m) {
				// \B的含义：非单词边界(在单词边界不匹配)
				return m.replace(/(?=(\B)(\d{3})+$)/g, ',');
			});
		} else {
			return Number(price);
		}
	};
}
